var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-base",class:_vm.color,style:({width: _vm.size + 'px', 'min-width': _vm.size + 'px', height: _vm.size + 'px'})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }